import { motion } from "framer-motion";
import { Star, BadgeCheck, Check } from "lucide-react";

const REVIEWS = [
    {
        name: "Rohit Malhotra",
        city: "Mumbai",
        text: "12,000 books at ₹149 still doesn't feel real. Best investment of my life, hands down!",
    },
    {
        name: "Sneha Iyer",
        city: "Coimbatore",
        text: "Atomic Habits aur Deep Work dono ek hi bundle mein? Paisa vasool, totally!",
    },
    {
        name: "Arjun Mehta",
        city: "Gurugram",
        text: "Download link 2 minute mein aa gaya. Smooth experience, zero drama.",
    },
    {
        name: "Kavita Joshi",
        city: "Lucknow",
        text: "Hindi translations ka collection bahut accha hai. Ab maa bhi padh rahi hain!",
    },
    {
        name: "Vivek Ranjan",
        city: "Patna",
        text: "The AI category is loaded — prompts, guides, everything a freelancer needs.",
    },
    {
        name: "Ananya Das",
        city: "Kolkata",
        text: "Metro mein phone par padhti hoon — EPUBs properly formatted hain, koi issue nahi.",
    },
    {
        name: "Harpreet Singh",
        city: "Ludhiana",
        text: "Stock market section ne meri basics clear kar di. Thank you Drvn Dream!",
    },
    {
        name: "Meghna Reddy",
        city: "Hyderabad",
        text: "I was skeptical, but WhatsApp support replied at 11pm. Genuinely impressed!",
    },
    {
        name: "Farhan Shaikh",
        city: "Mumbai",
        text: "Psychology of Money aur Rich Dad Poor Dad — Hindi mein bhi. Ekdum badhiya!",
    },
    {
        name: "Divya Nair",
        city: "Kochi",
        text: "Placement prep ke liye liya tha, marketing books bhi padh liye. Total gold mine!",
    },
    {
        name: "Suresh Babu",
        city: "Chennai",
        text: "One payment, lifetime access. No subscription tension. Exactly what I wanted.",
    },
    {
        name: "Pooja Rani",
        city: "Jaipur",
        text: "Self-improvement section is massive — 5 stars from my side!",
    },
    {
        name: "Aditya Kulkarni",
        city: "Pune",
        text: "Shared it with my college group — sabne usi din buy kar liya. Value is undeniable.",
    },
    {
        name: "Neha Gupta",
        city: "Indore",
        text: "Ikigai, Atomic Habits, 48 Laws — sab ek jagah. Meri reading list ek saal sorted!",
    },
    {
        name: "Imran Khan",
        city: "Bhopal",
        text: "Google Drive link instantly mila. PDF quality genuinely good hai.",
    },
    {
        name: "Lakshmi Priya",
        city: "Visakhapatnam",
        text: "Freelancing guides se mera first client mila. ₹149 is nothing compared to that!",
    },
    {
        name: "Rajesh Prajapat",
        city: "Ahmedabad",
        text: "Trading aur personal finance dono covered hain. Family ke liye bhi le liya.",
    },
    {
        name: "Simran Kaur",
        city: "Chandigarh",
        text: "Audiobooks bonus is my favourite part — travel karte hoon to sun leti hoon.",
    },
    {
        name: "Manish Verma",
        city: "Kanpur",
        text: "English and Hindi dono milte hain — itna collection is price mein kahin nahi.",
    },
    {
        name: "Tanvi Deshmukh",
        city: "Nagpur",
        text: "Bhai, itne saare books ₹149 mein? Doston ko bhi link bhej diya. Must buy!",
    },
];

function Stars() {
    return (
        <span className="flex gap-0.5 text-emerald-500">
            {Array.from({ length: 5 }).map((_, i) => (
                <Star
                    key={i}
                    size={15}
                    fill="currentColor"
                    strokeWidth={0}
                />
            ))}
        </span>
    );
}

export default function Testimonials() {
    return (
        <section
            id="reviews"
            data-testid="testimonials-section"
            className="scroll-mt-24 py-16 sm:py-24"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.6 }}
                    className="mx-auto max-w-2xl text-center"
                >
                    <h2 className="font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-[2.75rem]">
                        Loved by{" "}
                        <span className="text-emerald-600">2,400+ Learners</span>
                    </h2>
                    <div
                        data-testid="reviews-rating-row"
                        className="mt-4 flex items-center justify-center gap-2"
                    >
                        <Stars />
                        <span className="font-display text-sm font-extrabold text-slate-900">
                            4.9/5
                        </span>
                    </div>
                    <p className="mt-2 text-sm text-slate-500">
                        Based on verified buyer feedback
                    </p>
                </motion.div>

                <div className="mt-10 gap-4 sm:columns-2 lg:columns-3 sm:gap-5">
                    {REVIEWS.map((r, i) => (
                        <motion.div
                            key={r.name}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.1 }}
                            transition={{ duration: 0.45, delay: (i % 3) * 0.07 }}
                            data-testid="review-card"
                            className="mb-4 break-inside-avoid rounded-2xl border border-emerald-100 bg-white p-5 shadow-soft sm:mb-5 sm:p-6"
                        >
                            <Stars />
                            <p className="mt-3 text-sm leading-relaxed text-slate-600">
                                "{r.text}"
                            </p>
                            <div className="mt-4 flex items-center gap-3">
                                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-emerald-500 to-emerald-700 font-display text-sm font-bold text-white">
                                    {r.name[0]}
                                </span>
                                <span>
                                    <span className="flex items-center gap-1 text-sm font-bold text-slate-900">
                                        {r.name}
                                        <BadgeCheck
                                            size={15}
                                            className="text-amber-500"
                                        />
                                    </span>
                                    <span className="mt-0.5 flex items-center gap-1 text-xs text-slate-500">
                                        {r.city} • Verified Buyer
                                        <Check
                                            size={11}
                                            strokeWidth={3.5}
                                            className="text-emerald-500"
                                        />
                                    </span>
                                </span>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
